// extracted by mini-css-extract-plugin
export default {"container":"uq-z","ratingLayout":"vq-z","ratingLabel":"wq-z","nonInteractiveRatingLabel":"xq-z"};